import { useDispatch,useSelector } from "react-redux";
import { setOnboardingInfo } from "../../../../redux/slices/onboarding";
import { setOrganizationUpdateSuccess } from "../../../../redux/slices/organization";
import { useNavigate } from "react-router-dom";
import { useOrganizationList } from "@clerk/clerk-react";
import { Select } from "flowbite-react";
import  useOrganizationService from '../../../../services/organization';
import { useJwt } from "../../../../helpers/common";
import { useEffect,useState } from "react";
import { HiBadgeCheck } from "react-icons/hi";
import OnboardingCarousel from "../OnboardingCarousel";
import {
  Spinner
} from "flowbite-react";


 const OrgInfo =  () => {
  const navigate = useNavigate();
  const [orgId,setOrgId] =  useState('')
    const JWTdata = useJwt()
    const { createOrganization,organizationList,setActive } = useOrganizationList();
    const { createOrg } = useOrganizationService();
    const onboardingData = useSelector((state: any) => state.onboarding);
    const {orgUpdateSuccess=false,orgUpdateLoading,loading} = useSelector((state: any) => state.organization);
    const dispatch = useDispatch();

    const handleContinue = async () => {
        if(typeof createOrganization == "function" && !orgUpdateLoading){
              const data  = await createOrganization({ name: onboardingData.company.name });
              await createOrg({ name: onboardingData.company.name,org_id:data.id,user_id:JWTdata.user_id });
              if(data.id){
                  setOrgId(data.id)
                  if(typeof setActive == "function"){
                      await setActive({ organization: data.id })
                  }
              }
        }
    }
    useEffect(()=>{
      setTimeout(async ()=>{
        if(orgUpdateSuccess && orgId) {
          if(typeof setActive == "function"){
              await setActive({ organization: orgId })
          }
          dispatch(setOrganizationUpdateSuccess(false));
          navigate("/onboarding/profileinfo")
        }
      },1000)
    },[orgUpdateSuccess,orgId])
    
    useEffect(()=>{
      (async()=>{
        if(JWTdata.org_name) {
          if(typeof setActive == "function"){
              await setActive({ organization: orgId })
              
          }
          dispatch(setOnboardingInfo({ name: JWTdata.org_name }))
        }
      })()
    },[JWTdata])

    const handleTextChange = (e) => {
        e.preventDefault()
        dispatch(setOnboardingInfo({ name: e.target.value }))
    }

    

    const handleSkipClick = () =>{
      navigate("/onboarding/profileinfo")
    }

    return (
        <div className=" grid grid-cols-2 gap-5  h-[100vh] w-full relative">
        <div className="p-2 w-full h-[100vh]">
              <OnboardingCarousel />
        </div>
        {(orgUpdateLoading ||  loading) && <div className ="fixed top-0 right-0 left-0 bottom-0 opacity-50 bg-black z-40"> 
              <div className="text-center w-full h-full bottom-0">
                  <Spinner aria-label="Center-aligned spinner" />
              </div>
        </div>}
            
        
        <div tabIndex={-1} aria-hidden="true" className="flex flex-col items-center h-full justify-center relative w-full p-40" >
            {JWTdata.org_id && <div onClick={handleSkipClick} className=" text-white text-sm font-light leading-tight absolute top-10 right-10 cursor-pointer" >Skip</div>}
                <div className="relative w-full max-w-2xl h-full">
                <div className="opacity-50 text-center dark:text-white text-gray-600 text-lg font-normal leading-7 mb-2">Hey, {JWTdata?.username}</div>
                <div className="text-center dark:text-white text-gray-600 text-2xl font-normal leading-9 mb-8">Now we are setting up<br/>your organization</div>
                <div className="w-full h-5 justify-start items-center gap-4 inline-flex">
                    <div className="w-20 self-stretch rounded-md justify-center items-center gap-1.5 flex">
                      <div className="relative" ><HiBadgeCheck className=" text-blue-500" /></div>
                      <div className="text-blue-500  text-base font-medium leading-tight">Step 1</div>
                    </div>
                    <div className="grow shrink basis-0 h-px border border-gray-700"></div>
                    <div className="w-18 self-stretch justify-center items-center gap-1.5 flex">
                      <div className=" text-gray-400  text-base font-medium leading-tight">Step 2</div>
                    </div>
                    <div className="grow shrink basis-0 h-px border border-gray-700"></div>
                    <div className="w-18 self-stretch rounded-md justify-center items-center gap-1.5 flex">
                    
                      <div className=" text-gray-400 text-base font-medium leading-tight">Step 3</div>
                    </div>
                  </div>
                    <div className="relative pr-4 pl-4 bg-white w-full dark:bg-[#111928] sm:p-5">
                        <form action="#">
                            <div className="gap-4 flex flex-col mb-10">
                                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Company Name</label>
                                <input onChange={(e) => handleTextChange(e)} defaultValue={onboardingData.company.name} type="text" name="name" id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Your company name" required />
                            </div>
                            <div className="flex mb-2">
                              <div onClick={handleContinue} className={`w-40 h-9 ml-auto px-5 py-3 ${(orgUpdateLoading  || loading) ? "bg-blue-300" : "bg-blue-700 "} rounded-lg justify-center items-center gap-2 inline-flex cursor-pointer`}>
                                <div  className="text-white text-base font-medium leading-normal ">Next</div>
                              </div>
                            </div>
                            {/* <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">OR</label>
                            <div className="flex flex-col mb-10">
                              <OrganizationList orgId={JWTdata.org_id } />
                            </div> */}
                        </form>
                    </div>
                    
                </div>
        </div>
         
        </div>
    )
}

export default OrgInfo;

export const OrganizationList = ({orgId}) => {
  const JWTdata = useJwt();
  const [orgid,setOrgId] = useState()
  const dispatch = useDispatch();
  const [userData,setUserData] = useState({company_size:'',team_size:'',department:''});
    const { organizationList, isLoaded, setActive } = useOrganizationList();
    const { updateOrganization } = useOrganizationService();
    const {orgUpdateSuccess=false, orgUpdateLoading=false} = useSelector((state: any) => state.organization);

    useEffect(()=>{
       dispatch(setOrganizationUpdateSuccess(false));
    },[]);

    useEffect(()=>{
      setOrgId(orgid);
    },[orgId]);

    useEffect(()=>{
        if(orgUpdateSuccess && orgid) {
          window.location.href = "/onboarding/profileinfo";
        }
    },[orgUpdateSuccess,orgid])

    if (!isLoaded) {
      // show loading state
      return null;
    }
    
    const handleSetAvctive = async (id: any) => {
        if(typeof setActive == "function"){
          await setActive({ organization: id })
          setOrgId(id)
          window.location.href = "/onboarding/profileinfo";
        }
            
    }

    const handleContinue = async () => {
      if(!orgUpdateLoading){
        await updateOrganization(orgid,{...userData})
      }
    }

    
  
    return (
      <div tabIndex={-1} aria-hidden="true" className=" flex justify-center w-full" >
        <div className="relative w-full shadow-sm flex items-center justify-center">
            <div className="relative bg-white w-full dark:bg-[#111928]">
              {organizationList && organizationList.length === 0 ? (
                <div>You do not belong to any organizations yet.</div>
              ) : (
                <Select value={orgid} className="mb-5" onChange={(e)=>handleSetAvctive(e.target.value)}>
                  <option className="py-1 text-sm text-gray-700 dark:text-gray-200">
                        Select Org
                  </option>
                  {organizationList && organizationList.map(({ organization, membership }) => {
                      
                      return (
                          <option value={organization?.id} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={organization.id}>
                            {organization.name}
                          </option>
                        )
                  })}
                </Select>
              )}
              
            </div>
        </div>
      </div>
    );
  };
